<template>
  <div class="app-breadcrumb">
    <h2>{{ title }}</h2>
    <slot name="title"></slot>
  </div>
</template>

<script>
export default {
  name: 'app-breadcrumb',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/app-breadcrumb.vue